import { DataProvider, IScreenModel, ITextComponentModel } from "@nf/common";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { firstValueFrom } from "rxjs";

import type { ICommonProps } from "helpers/getCommonServerSideProps";
import NotAvailableScreen, {
  type NotAvailableComponent,
  type NotAvailableScreenProps,
} from "screens/NotAvailableScreen";

export const getServerSideProps: GetServerSideProps<
  NotAvailableScreenProps & ICommonProps
> = async (ctx) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );

  const { commonProps } = await getCommonServerSideProps(ctx);

  const { setCacheHeader } = await import("helpers/cacheHeaderHelper");

  setCacheHeader(ctx.res);

  let screen: IScreenModel = {};

  try {
    screen = await firstValueFrom(
      DataProvider.getScreenComponentBody("not-available")
    );
  } catch (e) {
    console.log("Error while fetching 'not-available' screen data", e);
  }

  return {
    props: {
      component: (screen?.Components?.[0] as ITextComponentModel)
        ?.TextParsed as NotAvailableComponent,
      ...commonProps,
    },
  };
};

const NotAvailablePage = (props: NotAvailableScreenProps) => {
  return <NotAvailableScreen {...props} />;
};

NotAvailablePage.getLayout = function getLayout(page: ReactElement) {
  return page;
};

export default NotAvailablePage;
